import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { ClientAccountClient } from "../../../../../../Wrap/Api/Account/ClientAccount";
import { PensionContributionInstructionClient } from "../../../../../../Wrap/Api/Apply/PensionContributionInstruction";
import { SubAccountAmendmentInstructionClient } from "../../../../../../Wrap/Api/Apply/SubAccountAmendmentInstruction";
import { ProcessType as ActivityType } from "../../../../../../Wrap/Constants/Enums/Client/DashboardFilter/ProcessType";
import { PensionArrangementClient } from "../../../../../../Wrap/Api/Drawdown/PensionArrangement";
import { PensionContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountDispatcher } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { TopUpWithITFLSDispatcher, TopUpWithITFLSStore } from "../Stores/Variable";

export class ITFLSAction {
    public static getInstruction(id, hierarchyId, clientId): void {
        //Get subaccount hiearchy first
        const client = new ClientAccountClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            ClientAccountDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            const subAccount = result.SubAccounts.find((x) =>
                SubAccountTypeHelper.isOnPlatformPension(x.SubAccountType)
            );
            if (subAccount) {
                const pensionContributionInstruction = new PensionContributionInstructionClient();
                this.getOrCreateInstruction(
                    pensionContributionInstruction,
                    id,
                    hierarchyId,
                    subAccount.HierarchyId,
                    clientId
                );
            }
        });
        promise.onError((err) => {});
    }

    private static getOrCreateInstruction(
        client: PensionContributionInstructionClient,
        id,
        hierarchyId,
        subAccountHierarchyId,
        clientId
    ) {
        if (id && id !== "") {
            // Have instructionId
            const promise = client.get(id, clientId, "", null);
            this.updateITFLSInstructionStore(promise);
        } else {
            // Create new instruction
            const promise = client.post(subAccountHierarchyId, hierarchyId, ActivityType.Topup);
            promise.onSuccess((result) => {
                const instructionId = result.Result;
                const model = client.get(instructionId, clientId, "", null);
                this.updateITFLSInstructionStore(model);
            });

            promise.onError((err) => {
                TopUpWithITFLSDispatcher.dispatch({
                    actionType: ActionType.Error,
                    payload: err,
                });
            });
        }
    }

    public static saveInstruction(from, data: any, type, customerId?: number, callback?: (data) => void): void {
        const pensionContributionInstruction = new PensionContributionInstructionClient();
        const promise = pensionContributionInstruction.put(data, customerId);
        this.updateITFLSInstructionStore(promise, callback);
    }

    public static submitInstruction(id, data, customerId, claccountId, callback?: (data) => void): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.put(id, data, customerId, claccountId);
        promise.onSuccess((result) => {
            if (callback) {callback([]);}
        });
    }

    public static deleteInstruction(id, callback?: VoidFunction): void {
        const client = new SubAccountAmendmentInstructionClient();
        const promise = client.delete(id);
        promise.onSuccess((result) => {
            if (callback) {callback();}
        });
    }

    public static createIncomeAmendmentInstructions(data: PensionContributionModel, id, clientId): void {
        const incomeClient = new PensionArrangementClient();
        const promise = incomeClient.post(data);
        promise.onSuccess(() => {
            const client = new PensionContributionInstructionClient();
            const promise = client.get(id, clientId, "", null);
            this.updateITFLSInstructionStore(promise);
        });
    }

    private static updateITFLSInstructionStore(promise: any, callback?: (data) => void) {
        promise.onSuccess((result) => {
            TopUpWithITFLSDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callback) {callback([]);}
        });

        promise.onError((err) => {
            TopUpWithITFLSDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
